import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { useLocation } from 'react-router-dom';

import './Header.scss';
import { AccountLink } from 'components/common/AccountLink/AccountLink';
import { APP_CONTENT, ROUTES } from 'other/constants';
import { IconButton } from 'components/common/buttons/IconButton/IconButton';
import { Logo } from 'components/common/logos/Logo/Logo';
import NotificationButton from './Notification/NotificationButton';
import { Search } from 'components/common/inputs/Search/Search';
import { TrialLink } from 'components/common/TrialLink/TrialLink';

/**/
const scrollYOffset = 50;
const getPopupContainer = () => document.body;

type Props = {
  isAsideOpen: boolean;
  isLoggedIn: boolean;
  toggleAside: () => void;
};

/**
 *
 */
export function Header({ isAsideOpen, isLoggedIn, toggleAside }: Props) {
  const location = useLocation();
  const [isScrolled, setScrolled] = useState(false);

  const isFixed = !isLoggedIn && location.pathname === ROUTES.HOME;
  const iconName = isAsideOpen ? 'arrow-left' : 'menu';

  const cls = classnames('Header', {
    'Header--fixed': isFixed,
    'Header--scrolled': isScrolled
  });

  /**/
  useEffect(() => {
    const mainContainer = document.getElementById(APP_CONTENT);

    const stickyHeaderOnScroll = () => {
      const active = mainContainer.scrollTop > scrollYOffset;
      setScrolled(active);
    };

    if (isFixed) {
      mainContainer.addEventListener('scroll', stickyHeaderOnScroll);
    } else {
      setScrolled(false);
      mainContainer.removeEventListener('scroll', stickyHeaderOnScroll);
    }

    return () =>
      mainContainer.removeEventListener('scroll', stickyHeaderOnScroll);
  }, [location, isFixed]);

  /**/
  return (
    <header className={cls}>
      <div className="Header__container">
        <IconButton
          className="Header__burger"
          data-testid="Burger"
          icon={iconName}
          onClick={toggleAside}
          size="S"
        />

        <Logo />

        {isLoggedIn && (
          <Search
            className="Header__search"
            getPopupContainer={getPopupContainer}
          />
        )}

        <div className="Header__group">
          <TrialLink isPrimary={true} />
          <NotificationButton />
          <AccountLink isLoggedIn={isLoggedIn} />
        </div>
      </div>
    </header>
  );
}
